"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var RadioButton_1 = __importDefault(require("../RadioButton"));
var RadioButtonField = function (_a) {
    var id = _a.id, label = _a.label, input = _a.input, disabled = _a.disabled;
    return (react_1["default"].createElement(StyledLabel, { htmlFor: id || input.value },
        react_1["default"].createElement(RadioButton_1["default"], __assign({ id: id || input.value, disabled: Boolean(disabled), label: label || '' }, input))));
};
var StyledLabel = styled_components_1["default"].label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: all;\n  cursor: pointer;\n"], ["\n  pointer-events: all;\n  cursor: pointer;\n"])));
RadioButtonField.displayName = 'RadioButtonField';
exports["default"] = RadioButtonField;
var templateObject_1;
//# sourceMappingURL=RadioButtonField.js.map